export class HomeSlider{

	constructor(){

		this.slider = $('.c-box__slider');
		this.init();

	}


	init(){

		this.slider.slick({
			dots: true,
			arrows: false,
			infinite: true,
			speed: 1000,
			fade: true,
			autoplay: true,
			autoplaySpeed: 2000,
			cssEase: 'linear'
		});

	}

}


// WEBPACK FOOTER //
// ./src/js/modules/home-slider.js